import { FETCH_SALES, ADD_SALE } from '../constants/actionTypes';

const initialState = {
  list: [],
};

const sales = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SALES:
      return {
        ...state,
        list: action.payload || [],
      };

    case ADD_SALE:
      return {
        ...state,
        list: [action.payload, ...(state.list || [])],
      };

    default:
      return state;
  }
};

export default sales;
